const drawerShrinkWidth = 84;
const drawerWidth = 200;
const subDrawerWidth = 200;

const style = (theme): any => ({
    root: {
        display: 'flex',
    },
    drawer: {
        '& .MuiListItem-gutters': {
            margin: 0,
            padding: 0,
            '& .MuiButton-root': {
                padding: theme.spacing(1, 2),
                flex: 1,
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'start',
                paddingLeft: 30,
                color: theme.palette.primary.contrastText,
                textTransform: 'none',
                '& .MuiButton-label': {
                    lineHeight: 1.4,
                    '& .MuiIcon-root': {
                        marginRight: theme.spacing(1),
                    },
                },
                '& .menuItemOption': {
                    position: 'absolute',
                    top: '50%',
                    right: 0,
                    transform: 'translateY(-50%)',
                    display: 'none',
                },
                '&:hover .menuItemOption': {
                    display: 'block',
                },
            },
            '&:hover': {
                backgroundColor: theme.palette.primary.dark,
            },
        },
    },
    drawerShrink: {
        [theme.breakpoints.up('sm')]: {
            width: drawerShrinkWidth,
            flexShrink: 0,
        },
    },
    drawerClose: {
        [theme.breakpoints.up('sm')]: {
            width: drawerWidth,
            flexShrink: 0,
        },
    },
    drawerOpen: {
        [theme.breakpoints.up('sm')]: {
            width: drawerWidth,
            marginRight: drawerWidth,
            flexShrink: 0,
        },
    },
    drawerPaper: {
        width: drawerWidth,
        backgroundColor: theme.palette.primary.light,
        overflow: 'hidden',
        overflowY: 'auto',
        transition: 'width 0.3s',
        '& > div': {
            width: drawerWidth,
        },
    },
    drawerShrinkPaper: {
        width: drawerShrinkWidth,
        backgroundColor: theme.palette.primary.light,
        overflow: 'hidden',
        transition: 'width 0.3s',
    },
    subMenu: {
        padding: 8,
        paddingRight: 4,
    },
    subDrawer: {
        [theme.breakpoints.up('sm')]: {
            width: subDrawerWidth,
            flexShrink: 0,
        },
    },
    subDrawerShrink: {
        [theme.breakpoints.up('sm')]: {
            width: 0,
            flexShrink: 0,
        },
    },
    '@keyframes expandAndShow': {
        from: { width: 0, overflow: 'hidden' },
        to: { width: drawerWidth, overflow: 'hidden' },
    },
    subDrawerPaper: {
        left: drawerWidth,
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.dark,
        overflow: 'hidden',
        '& > div': {
            width: subDrawerWidth,
        },
        '& .MuiListItem-gutters .MuiButton-root': {
            paddingLeft: theme.spacing(1),
        },
    },
    subDrawerPaperExpand: {
        width: subDrawerWidth,
        animationName: '$expandAndShow',
        animationDuration: '0.3s',
        overflow: 'visible',
    },
    subDrawerPaperShrink: {
        width: 0,
        transition: 'width 0.3s',
        borderRight: 'none',
    },
    subDrawerCloseButton: {
        position: 'absolute',
        bottom: 200,
        left: subDrawerWidth - 26,
        zIndex: 2000,
        backgroundColor: theme.palette.primary.light,
        '&:hover': {
            backgroundColor: theme.palette.primary.dark,
        },
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
    },
    menuButton: {
        marginRight: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            display: 'none',
        },
    },
    toolbar: {
        ...theme.mixins.toolbar,
        [theme.breakpoints.up('sm')]: {
            minHeight: 0,
        },
    },
    content: {
        flexGrow: 1,
        // Allow the flex item to shrink below its content's intrinsic width so that
        // inner scroll containers (e.g. wide tables) scroll instead of widening the page.
        minWidth: 0,
        // padding: theme.spacing(3),
        fontSize: '1.rem',
    },
    closeMenuButton: {
        marginRight: 'auto',
        marginLeft: 0,
        color: theme.palette.primary.contrastText,
    },
    nested: {
        '&.MuiListItem-gutters': {
            paddingLeft: theme.spacing(2),
            '& .MuiButton-root': {
                fontWeight: 300,
            },
        },
    },
    arrow: {
        position: 'absolute',
        right: 5,
        top: 7,
        color: theme.palette.primary.contrastText,
        backgroundColor: 'transparent',
    },
    selected: {
        borderRadius: '0 100px 100px 0',
        backgroundColor: theme.palette.secondary.main,
        '&:hover': {
            backgroundColor: theme.palette.secondary.light,
        },
    },
    text: {
        color: theme.palette.primary.contrastText,
    },
    profil: {
        display: 'flex',
        flexDirection: 'row',
        backgroundColor: '#333333',
        borderRadius: 30,
        marginTop: 16,
        marginBottom: 16,
        alignItems: 'center',
    },
    profilText: {
        textAlign: 'left',
        margin: 8,
        marginLeft: 16,
    },
    profilIcon: {
        marginRight: 8,
        [theme.breakpoints.up('sm')]: {
            marginRight: 12,
        },
    },
    iconWithoutEndMargin: {
        marginLeft: 8,
        backgroundColor: theme.palette.primary.light,
        '&.MuiIconButton-edgeEnd': {
            marginRight: 0,
        },
    },
});
export default style;
